/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Music({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M4.9 6.514v3.795A2.6 2.6 0 1 0 6.1 12.5V6.941l6.8-2.125V8.31a2.6 2.6 0 1 0 1.2 2.192V2.86a1.6 1.6 0 0 0-2.077-1.527l-6 1.875A1.6 1.6 0 0 0 4.9 4.735v1.779m7.48-4.036a.4.4 0 0 1 .52.382v.699L6.1 5.684v-.949a.4.4 0 0 1 .28-.382zM11.5 9.1a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8m-6.6 3.4a1.4 1.4 0 1 0-2.8 0 1.4 1.4 0 0 0 2.8 0" clipRule="evenodd" /></svg>;
}
;